module.exports = __webpack_public_path__ + "img/single.c1ea814d.png";